<template>
  <div>
    <TrusteeInfo
      v-if="fillType === SubjectFillType.MANUAL"
      :trustee-info-prop="trusteeInfo"
      :assignee-prop="assignee"
      :field-group="getTrusteeFieldGroup(role)"
      @send="$emit('send', $event)"
    >
      <template #footer="{ next }">
        <slot name="footer" :next="next"></slot>
      </template>
    </TrusteeInfo>

    <Assignee
      v-if="fillType === SubjectFillType.ASSIGNEE"
      :trustee-info-prop="trusteeInfo"
      :assignee-prop="assignee"
      :field-group="getTrusteeFieldGroup(role)"
      @send="$emit('send', $event)"
    >
      <template #footer="{ next }">
        <slot name="footer" :next="next"></slot>
      </template>
    </Assignee>
  </div>
</template>

<script>
import { FieldGroup } from '@/utils/fullStatementView';
import { getTrusteeFieldGroup } from '@/utils/common';
import { SubjectFillType } from '@/constants';
import TrusteeInfo from './TrusteeInfo';
import Assignee from '@/views/alternativeServices/AddStApplicant/ManualTrustee/EgrnTrustee/Assignee';

export default {
  name: 'Organization',
  components: {
    TrusteeInfo,
    Assignee,
  },
  props: {
    trusteeInfo: {
      type: Object,
    },
    assignee: {
      type: Object,
    },
    role: {
      type: String,
      required: true,
    },
    fillType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    FieldGroup,
    getTrusteeFieldGroup,
    SubjectFillType,
  }),
  computed: {
    trustee() {
      return this.trusteeInfo || this.assignee;
    },
  },
};
</script>
